import { render } from "./FeatureTag.vue?vue&type=template&id=07ff8d7f&scoped=true"
import script from "./FeatureTag.vue?vue&type=script&lang=js"
export * from "./FeatureTag.vue?vue&type=script&lang=js"

import "./FeatureTag.vue?vue&type=style&index=0&id=07ff8d7f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07ff8d7f"]])

export default __exports__